import { Button } from '@nike/eds'
import { Sort, SortAscending, SortDescending } from '@nike/nike-design-system-icons'

type SortableHeaderProps = {
  getCanSort: () => boolean
  getToggleSortingHandler: () => () => void
  getIsSorted: () => 'asc' | 'desc' | false
}

export function SortableHeader({
  getCanSort,
  getToggleSortingHandler,
  getIsSorted,
}: SortableHeaderProps) {
  return (
    <>
      {getCanSort() && (
        <Button
          variant='ghost'
          className='sortColumnButton'
          onClick={getToggleSortingHandler()}
          disableRipple
        >
          {getIsSorted() ? (
            getIsSorted() === 'asc' ? (
              <SortAscending className='design-system-icon-size-s' size='s' />
            ) : (
              <SortDescending className='design-system-icon-size-s' size='s' />
            )
          ) : (
            <Sort className='design-system-icon-size-s' size='s' />
          )}
        </Button>
      )}
    </>
  )
}
